import fetchAll from './fetchAll'
import dtFetchData from './PchInvoiceDataTable'
import fetchById from './fetchById'
import payable from './payable'
export default {
    fetchAll,
    dtFetchData,
    fetchById,
    payable,
}
